import { map } from "rxjs";
import { Entitlement } from "../../model";
import apiService from "../ApiService";

const getEntitlements = () => {
  return apiService
    .get<{ entitlements: Entitlement[] }>({
      path: "public/account/entitlements",
      crm: true,
    })
    .pipe(map((e) => (e.entitlements || []).filter((e) => e.plan)));
};
export { getEntitlements };
